<template>
  <el-container>
    <el-aside width="15%" class="bg-[#0d121d]">
      <Aside />
    </el-aside>
    <el-main class="bg-[#0d121d] h-[80rem]">
      <transition name="fade-slide" mode="out-in">
        <router-view />
      </transition>
    </el-main>
  </el-container>
</template>

<script>
import Aside from "./aside/index.vue";
export default {
  name: "Layout",
  components: { Aside },
};
</script>

<style scoped>
/* 定义动画效果 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .7s ease; /* 动画持续时间 */
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0.2; /* 初始透明度 */
  transform: translateX(20px); /* 初始位置偏移 */
}
</style>